"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = formatDate;
const date_fns_1 = require("date-fns");
function formatDate(date, formatString = 'yyyy-MM-dd HH:mm') {
    return (0, date_fns_1.format)(date, formatString);
}
//# sourceMappingURL=format-date.js.map